import type { ContactCreate } from "@/canvassFlow/types";
import type { Contact, ContactListItem, ContactQuery } from "@/contacts/types";
import { apiClient } from "./apiClient";

export const contactsGateway = {
  async listContacts(houseId?: number): Promise<Array<ContactListItem>> {
    if (houseId !== undefined) {
      return await apiClient.get(`/api/contacts?house-id=${houseId}`);
    }

    return await apiClient.get("/api/contacts");
  },

  async getContact(id: string): Promise<ContactQuery> {
    return await apiClient.get(`/api/contacts/${id}`);
  },

  async createContact(contact: ContactCreate): Promise<ContactQuery> {
    return await apiClient.post("/api/contacts", contact);
  },

  async updateContact(contact: Contact): Promise<ContactQuery> {
    return await apiClient.put(`/api/contacts/${contact.id}`, contact);
  },

  async deleteContact(contact: Contact | ContactListItem): Promise<Contact> {
    return await apiClient.delete(`/api/contacts/${contact.id}`);
  },

  async confirmEmail(token: string): Promise<void> {
    await apiClient.post(`/api/contacts/confirm-email/${token}`);
  },

  async confirmPhoneNumber(token: string): Promise<void> {
    await apiClient.post(`/api/contacts/confirm-phone-number/${token}`);
  },
};
